import client from '../client/client'

const getChannelCategoriesRequest = async () =>
  await client.get('api/admin/v1/channel-categories')

const assignChannelCategoryRequest = async (data: {
  channelId: number
  channelCategoryId: number | null // null unassigns the channel
}) => await client.put('api/admin/v1/channel-categories/assign', data)

export {getChannelCategoriesRequest, assignChannelCategoryRequest}
